import Box from 'components/atomic/atoms/box'
import Card from 'components/atomic/molecules/card'
import Anchor from 'components/pages/@shared/mdx/anchor'

const CardWidget = ({ href, children }) => {
  const wrapper = content => (
    <Box data-widget="card">
      {href ? (
        <Anchor href={href}>
          <Box
            css={{
              '&:hover > div': {
                borderColor: '$text2',
              },
            }}
          >
            {content}
          </Box>
        </Anchor>
      ) : (
        content
      )}
    </Box>
  )

  return wrapper(
    <Card.Root
      bgc="2"
      css={{ borderColor: '$transparent', transition: 'border-color .2s ease' }}
    >
      <Card.Body
        css={{
          color: '$text2 !important',
        }}
      >
        {children}
      </Card.Body>
    </Card.Root>,
  )
}

export default CardWidget
